module.exports = __webpack_public_path__ + "assets/img/98f0205f24d0216c932c6edadd5de2d3.png";